module.exports = __webpack_public_path__ + "img/ip-logo--bg.aa49e60b.svg";